import { render, staticRenderFns } from "./CardProfilePrices.vue?vue&type=template&id=7b68a159"
import script from "./CardProfilePrices.vue?vue&type=script&lang=js"
export * from "./CardProfilePrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports